'use strict';

import ckb from './ckb';
import cs from './cs';
import da from './da';
import de from './de';
import en from './en';
import es from './es';
import fa from './fa';
import fr from './fr';
import he from './he';
import hu from './hu';
import it from './it';
import ja from './ja';
import ko from './ko';
import km from './km';
import lv from './lv';
import nl from './nl';
import pl from './pl';
import pt_br from './pt_br';
import ro from './ro';
import ru from './ru';
import se from './se';
import tr from './tr';
import ua from './ua';
import ur from './ur';
import zh_cn from './zh_cn';

export { ckb, cs, da, de, en, es, fa, fr, he, hu, it, ja, ko, km, lv, nl, pl, pt_br, ro, ru, se, tr, ua, ur, zh_cn };
export default { ckb, cs, da, de, en, es, fa, fr, he, hu, it, ja, ko, km, lv, nl, pl, pt_br, ro, ru, se, tr, ua, ur, zh_cn };
